export const TRANSLATION = 'builder.dashboard.learning_hub'

export function truncate(str: string, maxLength: number) {
  if (str.length <= maxLength) {
    return str
  }
  const truncated = str.slice(0, maxLength - 3)
  return truncated + '...'
}
